import { memo } from 'react'
import { Briefcase, Banknote } from 'lucide-react'
import { useUsdcBalance } from '@/hooks/useUsdcBalance'
import { usePortfolioValue } from '@/hooks/usePortfolioValue'
import { usePmWalletStore } from '@/store/pmWalletStore'
import { useSubscription } from '@/hooks/useSubscription'
import { RedeemPill } from './RedeemPill'

/**
 * В шапке: портфель + доступный остаток + пилюля клейма выигрышей.
 * Показывается ТОЛЬКО при активной подписке/trial. Expired-юзер видит
 * чистую шапку (морковка) — никаких своих данных.
 * Redeem в Visual — ручной через RedeemPill (без автоклейма).
 */
export const StreakBar = memo(function StreakBar() {
  const { balance } = useUsdcBalance()
  const activeWallet = usePmWalletStore((s) => s.activeWallet)
  const pmProxyAddress = usePmWalletStore((s) => s.pmProxyAddress)
  const activeAddress = activeWallet === 'pm' ? pmProxyAddress : null
  const { isActive } = useSubscription()
  const { value: portfolioPositions } = usePortfolioValue(isActive ? activeAddress ?? undefined : undefined)

  if (!isActive) return null

  const portfolioTotal = (portfolioPositions ?? 0) + (balance ?? 0)
  const available = balance ?? 0

  return (
    <div className="flex items-center gap-2 text-[#fafafa] sm:gap-3">
      <RedeemPill />
      <div className="flex min-w-0 items-center gap-1 sm:gap-1.5">
        <Briefcase className="h-3.5 w-3.5 shrink-0 text-[#94a3b8] sm:h-4 sm:w-4" aria-hidden />
        <span className="truncate tabular-nums text-xs sm:text-sm">{portfolioTotal.toFixed(2)}</span>
      </div>
      <div className="flex min-w-0 items-center gap-1 sm:gap-1.5">
        <Banknote className="h-3.5 w-3.5 shrink-0 text-[#94a3b8] sm:h-4 sm:w-4" aria-hidden />
        <span className="truncate tabular-nums text-xs sm:text-sm">{available.toFixed(2)}</span>
      </div>
    </div>
  )
})
